
// CONFIGURATION
export const CONFIGURATION_REQUEST = 'CONFIGURATION_REQUEST';
export const CONFIGURATION_SUCCESS = 'CONFIGURATION_SUCCESS';
export const CONFIGURATION_FAILURE = 'CONFIGURATION_FAILURE';
export const SET_CLIENT_CONTEXT = 'SET_CLIENT_CONTEXT';

// SIGN_IN
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

// SIGN_IN GUEST
export const SIGN_IN_GUEST_REQUEST = 'SIGN_IN_GUEST_REQUEST';
export const SIGN_IN_GUEST_SUCCESS = 'SIGN_IN_GUEST_SUCCESS';
export const SIGN_IN_GUEST_FAILURE = 'SIGN_IN_GUEST_FAILURE';

// SIGN_UP
export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

// FOR GET BANNERS LIST
export const BANNERS_LIST_REQUEST = 'BANNERS_LIST_REQUEST';
export const BANNERS_LIST_SUCCESS = 'BANNERS_LIST_SUCCESS';
export const BANNERS_LIST_FAILURE = 'BANNERS_LIST_FAILURE';

// FOR GET SEGMENT LIST
export const SEGMENT_LIST_REQUEST = 'SEGMENT_LIST_REQUEST';
export const SEGMENT_LIST_SUCCESS = 'SEGMENT_LIST_SUCCESS';
export const SEGMENT_LIST_FAILURE = 'SEGMENT_LIST_FAILURE';

// FOR GET STORES LIST
export const STORES_LIST_REQUEST = 'STORES_LIST_REQUEST';
export const STORES_LIST_SUCCESS = 'STORES_LIST_SUCCESS';
export const STORES_LIST_FAILURE = 'STORES_LIST_FAILURE';

// FOR GET RECENTLY BROWSE PRODUCT
export const RECENTLY_BROWSE_REQUEST = 'RECENTLY_BROWSE_REQUEST';
export const RECENTLY_BROWSE_SUCCESS = 'RECENTLY_BROWSE_SUCCESS';
export const RECENTLY_BROWSE_FAILURE = 'RECENTLY_BROWSE_FAILURE';

//PREVIOUS ORDERS LIST
export const GET_PREVIOUS_ORDERS_REQUEST = 'GET_PREVIOUS_ORDERS_REQUEST';
export const GET_PREVIOUS_ORDERS_SUCCESS = 'GET_PREVIOUS_ORDERS_SUCCESS';
export const GET_PREVIOUS_ORDERS_FAILURE = 'GET_PREVIOUS_ORDERS_FAILURE';

// FOR GET LAST ORDER SEGMENT
export const GET_LAST_ORDER_SEGMENT_REQUEST = 'GET_LAST_ORDER_SEGMENT_REQUEST';
export const GET_LAST_ORDER_SEGMENT_SUCCESS = 'GET_LAST_ORDER_SEGMENT_SUCCESS';
export const GET_LAST_ORDER_SEGMENT_FAILURE = 'GET_LAST_ORDER_SEGMENT_FAILURE';

// FOR GET BRAND LIST 
export const GET_BRAND_LIST_REQUEST = 'GET_BRAND_LIST_REQUEST';
export const GET_BRAND_LIST_SUCCESS = 'GET_BRAND_LIST_SUCCESS';
export const GET_BRAND_LIST_FAILURE = 'GET_BRAND_LIST_FAILURE';

// FOR GET ORDERS LIST 
export const GET_ORDERS_LIST_REQUEST = 'GET_ORDERS_LIST_REQUEST';
export const GET_ORDERS_LIST_SUCCESS = 'GET_ORDERS_LIST_SUCCESS';
export const GET_ORDERS_LIST_FAILURE = 'GET_ORDERS_LIST_FAILURE';

// FOR GET ORDERS DETAIL 
export const GET_ORDERS_DETAIL_REQUEST = 'GET_ORDERS_DETAIL_REQUEST';
export const GET_ORDERS_DETAIL_SUCCESS = 'GET_ORDERS_DETAIL_SUCCESS';
export const GET_ORDERS_DETAIL_FAILURE = 'GET_ORDERS_DETAIL_FAILURE';

// FOR TRACK ORDERS DETAIL 
export const TRACK_ORDERS_DETAIL_REQUEST = 'TRACK_ORDERS_DETAIL_REQUEST';
export const TRACK_ORDERS_DETAIL_SUCCESS = 'TRACK_ORDERS_DETAIL_SUCCESS';
export const TRACK_ORDERS_DETAIL_FAILURE = 'TRACK_ORDERS_DETAIL_FAILURE';

// FOR CANCEL ORDER 
export const GET_ORDER_CANCEL_REQUEST = 'GET_ORDER_CANCEL_REQUEST';
export const GET_ORDER_CANCEL_SUCCESS = 'GET_ORDER_CANCEL_SUCCESS';
export const GET_ORDER_CANCEL_FAILURE = 'GET_ORDER_CANCEL_FAILURE';

// FOR CANCEL ORDER REASON
export const GET_ORDER_CANCEL_REASON_REQUEST = 'GET_ORDER_CANCEL_REASON_REQUEST';
export const GET_ORDER_CANCEL_REASON_SUCCESS = 'GET_ORDER_CANCEL_REASON_SUCCESS';
export const GET_ORDER_CANCEL_REASON_FAILURE = 'GET_ORDER_CANCEL_REASON_FAILURE';

// FOR ADDING REPORT ISSUE
export const ADD_REPORT_ISSUE_REQUEST = 'ADD_REPORT_ISSUE_REQUEST';
export const ADD_REPORT_ISSUE_SUCCESS = 'ADD_REPORT_ISSUE_SUCCESS';
export const ADD_REPORT_ISSUE_FAILURE = 'ADD_REPORT_ISSUE_FAILURE';

// FOR GET REPORT ISSUE REASON
export const GET_REPORT_ISSUE_REASON_REQUEST = 'GET_REPORT_ISSUE_REASON_REQUEST';
export const GET_REPORT_ISSUE_REASON_SUCCESS = 'GET_REPORT_ISSUE_REASON_SUCCESS';
export const GET_REPORT_ISSUE_REASON_FAILURE = 'GET_REPORT_ISSUE_REASON_FAILURE';

// FOR GET SOS LIST
export const GET_SOS_LIST_REQUEST = 'GET_SOS_LIST_REQUEST';
export const GET_SOS_LIST_SUCCESS = 'GET_SOS_LIST_SUCCESS';
export const GET_SOS_LIST_FAILURE = 'GET_SOS_LIST_FAILURE';

// FOR GET REFER DETAILS
export const GET_REFER_DETAILS_REQUEST = 'GET_REFER_DETAILS_REQUEST';
export const GET_REFER_DETAILS_SUCCESS = 'GET_REFER_DETAILS_SUCCESS';
export const GET_REFER_DETAILS_FAILURE = 'GET_REFER_DETAILS_FAILURE';

//FOR USER UPDATE PASSWORD
export const USER_UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST';
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS';
export const USER_UPDATE_PASSWORD_FAILURE = 'USER_UPDATE_PASSWORD_FAILURE';

// FOR POST PRODUCT RATE
export const GET_PRODUCT_RATE_REQUEST = 'GET_PRODUCT_RATE_REQUEST';
export const GET_PRODUCT_RATE_SUCCESS = 'GET_PRODUCT_RATE_SUCCESS';
export const GET_PRODUCT_RATE_FAILURE = 'GET_PRODUCT_RATE_FAILURE';

// FOR POST ORDER RATE
export const GET_ORDER_RATE_REQUEST = 'GET_ORDER_RATE_REQUEST';
export const GET_ORDER_RATE_SUCCESS = 'GET_ORDER_RATE_SUCCESS';
export const GET_ORDER_RATE_FAILURE = 'GET_ORDER_RATE_FAILURE';

// FOR SAVE PRODUCT CART 
export const SAVE_PRODUCT_CART_REQUEST = 'SAVE_PRODUCT_CART_REQUEST';
export const SAVE_PRODUCT_CART_SUCCESS = 'SAVE_PRODUCT_CART_SUCCESS';
export const SAVE_PRODUCT_CART_FAILURE = 'SAVE_PRODUCT_CART_FAILURE';

// FOR GET PRODUCT CART 
export const GET_PRODUCT_CART_REQUEST = 'GET_PRODUCT_CART_REQUEST';
export const GET_PRODUCT_CART_SUCCESS = 'GET_PRODUCT_CART_SUCCESS';
export const GET_PRODUCT_CART_FAILURE = 'GET_PRODUCT_CART_FAILURE';

// FOR GET PROMO CODE LIST 
export const GET_PROMO_CODE_LIST_REQUEST = 'GET_PROMO_CODE_LIST_REQUEST';
export const GET_PROMO_CODE_LIST_SUCCESS = 'GET_PROMO_CODE_LIST_SUCCESS';
export const GET_PROMO_CODE_LIST_FAILURE = 'GET_PROMO_CODE_LIST_FAILURE';

//FOR APPLY REMOVE_PROMO_CODE
export const APPLY_REMOVE_PROMO_CODE_REQUEST = 'APPLY_REMOVE_PROMO_CODE_REQUEST'; 
export const APPLY_REMOVE_PROMO_CODE_SUCCESS = 'APPLY_REMOVE_PROMO_CODE_SUCCESS';
export const APPLY_REMOVE_PROMO_CODE_FAILURE = 'APPLY_REMOVE_PROMO_CODE_FAILURE';

// FOR GET CART RELATED ITEM 
export const GET_CART_RELATEDITEM_LIST_REQUEST = 'GET_CART_RELATEDITEM_LIST_REQUEST';
export const GET_CART_RELATEDITEM_LIST_SUCCESS = 'GET_CART_RELATEDITEM_LIST_SUCCESS';
export const GET_CART_RELATEDITEM_LIST_FAILURE = 'GET_CART_RELATEDITEM_LIST_FAILURE';

// LOCAL CART
export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITY = 'CART_UPDATE_QUANTITY';
export const CART_UPDATE_PORTION = 'CART_UPDATE_PORTION';
export const CART_CLEAR = 'CART_CLEAR';

// FOR GET ADDRESS LIST 
export const TRIGGERS_LIST_UNDER_REQUEST = 'TRIGGERS_LIST_UNDER_REQUEST';
export const TRIGGERS_LIST_UNDER_SUCCESS = 'TRIGGERS_LIST_UNDER_SUCCESS';
export const TRIGGERS_LIST_UNDER_FAILURE = 'TRIGGERS_LIST_UNDER_FAILURE';

// FOR GET ADDRESS 
export const TRIGGERS_UPDATE_REQUEST = 'TRIGGERS_UPDATE_REQUEST';
export const TRIGGERS_UPDATE_SUCCESS = 'TRIGGERS_UPDATE_SUCCESS';
export const TRIGGERS_UPDATE_FAILURE = 'TRIGGERS_UPDATE_FAILURE';

// FOR GET ADDRESS SINGLE
export const TRIGGERS_SINGLE_REQUEST = 'TRIGGERS_SINGLE_REQUEST';
export const TRIGGERS_SINGLE_SUCCESS = 'TRIGGERS_SINGLE_SUCCESS';
export const TRIGGERS_SINGLE_FAILURE = 'TRIGGERS_SINGLE_FAILURE';

// FOR GET ADDRESS DELETE
export const TRIGGERS_DELETE_REQUEST = 'TRIGGERS_DELETE_REQUEST';
export const TRIGGERS_DELETE_SUCCESS = 'TRIGGERS_DELETE_SUCCESS';
export const TRIGGERS_DELETE_FAILURE = 'TRIGGERS_DELETE_FAILURE';

// FOR GET ADDRESS CREATE
export const TRIGGERS_CREATE_REQUEST = 'TRIGGERS_CREATE_REQUEST';
export const TRIGGERS_CREATE_SUCCESS = 'TRIGGERS_CREATE_SUCCESS';
export const TRIGGERS_CREATE_FAILURE = 'TRIGGERS_CREATE_FAILURE';

// FOR GET STOREDETAIL BY ID
export const GET_STOREDETAIL_REQUEST = 'GET_STOREDETAIL_REQUEST';
export const GET_STOREDETAIL_SUCCESS = 'GET_STOREDETAIL_SUCCESS';
export const GET_STOREDETAIL_FAILURE = 'GET_STOREDETAIL_FAILURE';

// FOR GET CATEGORIES BY STORE
export const GET_CATEGOURIES_REQUEST = 'GET_CATEGOURIES_REQUEST';
export const GET_CATEGOURIES_SUCCESS = 'GET_CATEGOURIES_SUCCESS';
export const GET_CATEGOURIES_FAILURE = 'GET_CATEGOURIES_FAILURE';

// FOR GET SUBCATEGORIES BY STORE
export const GET_SUBCATEGOURIES_REQUEST = 'GET_SUBCATEGOURIES_REQUEST';
export const GET_SUBCATEGOURIES_SUCCESS = 'GET_SUBCATEGOURIES_SUCCESS';
export const GET_SUBCATEGOURIES_FAILURE = 'GET_SUBCATEGOURIES_FAILURE';

// FOR GET CATEGORY PRODUCT
export const GET_CATEGORY_PRODUCT_REQUEST = 'GET_CATEGORY_PRODUCT_REQUEST';
export const GET_CATEGORY_PRODUCT_SUCCESS = 'GET_CATEGORY_PRODUCT_SUCCESS';
export const GET_CATEGORY_PRODUCT_FAILURE = 'GET_CATEGORY_PRODUCT_FAILURE';

// PRODUCT DETAILS
export const GET_PRODUCT_DETAILS_REQUEST = 'GET_PRODUCT_DETAILS_REQUEST';
export const GET_PRODUCT_DETAILS_SUCCESS = 'GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_FAILURE = 'GET_PRODUCT_DETAILS_FAILURE';

// FOR GET USERDATA
export const GET_USERDATA_REQUEST = 'GET_USERDATA_REQUEST';
export const GET_USERDATA_SUCCESS = 'GET_USERDATA_SUCCESS';
export const GET_USERDATA_FAILURE = 'GET_USERDATA_FAILURE';

 //EDIT USER DATA
export const EDIT_USERDATA_REQUEST = 'EDIT_USERDATA_REQUEST';
export const EDIT_USERDATA_SUCCESS = 'EDIT_USERDATA_SUCCESS';
export const EDIT_USERDATA_FAILURE = 'EDIT_USERDATA_FAILURE';

// FOR PLACE ORDER
export const PLACE_ORDER_REQUEST = 'PLACE_ORDER_REQUEST';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';

// RE ORDER
export const RE_ORDER_REQUEST = 'RE_ORDER_REQUEST';
export const RE_ORDER_SUCCESS = 'RE_ORDER_SUCCESS';
export const RE_ORDER_FAILURE = 'RE_ORDER_FAILURE';

//GET ITEMS FOR RETURN
export const GET_ITEMS_FOR_RETURN_REQUEST = 'GET_ITEMS_FOR_RETURN_REQUEST';
export const GET_ITEMS_FOR_RETURN_SUCCESS = 'GET_ITEMS_FOR_RETURN_SUCCESS';
export const GET_ITEMS_FOR_RETURN_FAILURE = 'GET_ITEMS_FOR_RETURN_FAILURE';

//RETURN ORDER ITEMS
export const RETURN_ITEMS_REQUEST = 'RETURN_ITEMS_REQUEST';
export const RETURN_ITEMS_SUCCESS = 'RETURN_ITEMS_SUCCESS';
export const RETURN_ITEMS_FAILURE = 'RETURN_ITEMS_FAILURE';

//VIEW SUBSITUTION DETAIL
export const VIEW_SUBSITUTION_DETAIL_REQUEST = 'VIEW_SUBSITUTION_DETAIL_REQUEST';
export const VIEW_SUBSITUTION_DETAIL_SUCCESS = 'VIEW_SUBSITUTION_DETAIL_SUCCESS';
export const VIEW_SUBSITUTION_DETAIL_FAILURE = 'VIEW_SUBSITUTION_DETAIL_FAILURE';

//SUBMIT SUBSITUTION DETAIL
export const SUBMIT_SUBSITUTION_DETAIL_REQUEST = 'SUBMIT_SUBSITUTION_DETAIL_REQUEST';
export const SUBMIT_SUBSITUTION_DETAIL_SUCCESS = 'SUBMIT_SUBSITUTION_DETAIL_SUCCESS';
export const SUBMIT_SUBSITUTION_DETAIL_FAILURE = 'SUBMIT_SUBSITUTION_DETAIL_FAILURE';

export const FILTER_API_CALL = 'FILTER_API_CALL';

// Change password  
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
// Edit Profile  
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';

// Get Social Links
export const GET_SOCIAL_LINKS_REQUEST = 'GET_SOCIAL_LINKS_REQUEST';
export const GET_SOCIAL_LINKS_SUCCESS = 'GET_SOCIAL_LINKS_SUCCESS';
export const GET_SOCIAL_LINKS_FAILURE = 'GET_SOCIAL_LINKS_FAILURE';

// Logout  
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const RESET_DATA = 'RESET_DATA';

export const SET_LOCATION = "SET_LOCATION";

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
